// import React from "react";
import useColors from "../firebase-files/hooks/useColors";
const ColorsComponent = () => {
  const { colors } = useColors();

  // Update CSS variables dynamically when colors change
  if (colors) {
    document.documentElement.style.setProperty(
      "--click-color",
      colors.clickColor
    );

    document.documentElement.style.setProperty(
      "--logo-primary-color",
      colors.logoPrimaryColor
    );
    document.documentElement.style.setProperty(
      "--logo-secondary-color",
      colors.logoSecondaryColor
    );

    document.documentElement.style.setProperty("--card-bg", colors.cardBgColor);

    document.documentElement.style.setProperty(
      "--heading-color",
      colors.headingColor
    );

    document.documentElement.style.setProperty(
      "--subheading-color",
      colors.subheadingColor
    );
    
    document.documentElement.style.setProperty(
      "--Session-Primarybg-Color",
      colors.SessionPrimarybgColor
    );

    document.documentElement.style.setProperty(
      "--Session-Secondarybg-Color",
      colors.SessionSecondarybgColor
    );

  }

  return <div></div>;
};

export default ColorsComponent;
